import { Outlet } from "react-router-dom";
import { ControlPortal } from "components/Organismos/Map/Controls/base/ControlPortal";
import CamadasProvider from "./contexts/CamadasProvider";
import { CamadasConsultaPrevia } from "./components/CamadasConsultaPrevia";
import { ConsultaPorPonto } from "./components/ConsultaPorPonto";
import { ControleCamadas } from "./components/ControleCamadas";
import { InputSearchCamadas } from "./components/InputSearchCamadas";
import { SidebarPonto } from "./components/SidebarPonto";

export const ConsultaPreviaInicio = () => {
  return (
    <CamadasProvider>
      <ControlPortal position="topleft">
        <InputSearchCamadas />
      </ControlPortal>

      <ControlPortal position="topleft" appendType="after">
        <ControleCamadas />
      </ControlPortal>

      <CamadasConsultaPrevia />
      <ConsultaPorPonto />
      <SidebarPonto />
      <Outlet />
    </CamadasProvider>
  );
};
